import styled from 'styled-components';

const Column = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  margin-bottom: var(--size-24);

  & > .card-wrapper {
    flex: 1;
  }
`;

const AnalyticsWrapper = styled.div``;

export { AnalyticsWrapper, Column, Row };
